import TemplateTile from "@components/paymentTemplates/TemplateTile";
import { usePaymentProfilesContext } from "@context/PaymentProfilesContext";

export default function TemplateSelectStep({
  templates,
  templatesLoading,
  onSelect,
  isSingleCustomer,
}) {
  const { profiles: paymentProfiles } = usePaymentProfilesContext();

  return (
    <div className="flex-1 overflow-y-auto p-5">
      {templatesLoading ? (
        <p className="text-sm text-zinc-500 text-center py-8">
          Loading templates…
        </p>
      ) : templates.length === 0 ? (
        <p className="text-sm text-zinc-500 text-center py-8">
          No templates found. Create one in Settings first.
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {templates.map((template) => (
            <TemplateTile
              key={template.id}
              template={template}
              onClick={onSelect}
              disabled={!isSingleCustomer && template.invoicesRequested == null}
              paymentProfiles={paymentProfiles}
            />
          ))}
        </div>
      )}
    </div>
  );
}
